// extracted by mini-css-extract-plugin
export default {"containerTable":"styles_containerTable__deiZC"};